import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getData } from '@yme/api';
import { HeaderCarouselDefault as HeaderCarousel, useCarousel } from '@yme/atoms/carousel';
import { ProductCarouselSkeleton } from '@yme/common/components/skeletons';
import { FEATURES_ATTR } from '@yme/common/constants';
import { useIsMount, useWindowSize } from '@yme/common/hooks';
import { IndentWrapper } from '@yme/components/Separator';
import { CollapsingFeaturesItemCard, GAP_BETWEEN_ITEMS, GAP_BETWEEN_ITEMS_MOBILE, } from '@yme/molecules/cards';
import { Features } from '@yme/organisms/features';
import { getCommonLabels, getRTL } from '@yme/selectors/index';
import { CARD_ITEM_SETTINGS } from './constants';
import { buildUrl, formattingFeatureItems } from './helpers';
import { getFeaturesIDs } from './redux/selectors';
export function ProductFeatures(data) {
    const { featuresEndpoint, labels, isRemoveBottomIndent, isInEditor } = data;
    const [features, setFeatures] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const featuresIDs = useSelector(getFeaturesIDs(FEATURES_ATTR));
    const isRightToLeft = useSelector(getRTL);
    const commonLabels = useSelector(getCommonLabels);
    const isMount = useIsMount();
    const { isInfiniteDesktopView } = useWindowSize();
    const { isMobileView } = useWindowSize();
    const { activeItem, onClickPrevItem, onClickNextItem, indexOfCount, counts, setCounts } = useCarousel();
    const commonProps = {
        counts,
        titleCarousel: labels.productFeatures_header_label,
        isRightToLeft,
        activeItem,
        onClickPrevItem,
        onClickNextItem,
        indexOfCount,
    };
    const arrowTitles = {
        titlePrev: commonLabels?.common_previousSlide_label,
        titleNext: commonLabels?.common_nextSlide_label,
    };
    useEffect(() => {
        if (featuresIDs && featuresIDs.length > 0 && !isMount) {
            getData(buildUrl(featuresEndpoint, featuresIDs))
                .then((result) => {
                setFeatures(result);
            })
                .finally(() => {
                setIsLoaded(true);
            });
        }
    }, [featuresEndpoint, featuresIDs, isMount]);
    if (!isLoaded && !isInEditor && featuresIDs && featuresIDs.length > 0) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(ProductCarouselSkeleton, { productHeight: isInfiniteDesktopView ? 528 : 576 })));
    }
    if (features.length > 0) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(Features
            // common props for functionality of carousel
            , { 
                // common props for functionality of carousel
                commonProps: commonProps, dataTestId: "pdp-features", isRightToLeft: isRightToLeft, 
                // Header Carousel Component with props
                HeaderCarouselComponent: React.createElement(HeaderCarousel, { ...commonProps, arrowTitles: arrowTitles, isArrowNavigationVisible: true }), 
                // Carousel props
                carouselProps: {
                    getterSize: isMobileView ? GAP_BETWEEN_ITEMS_MOBILE : GAP_BETWEEN_ITEMS,
                    items: formattingFeatureItems(features),
                    CardComponent: CollapsingFeaturesItemCard,
                    labels: commonLabels,
                    setCounts,
                    carouselConfig: CARD_ITEM_SETTINGS,
                    isDotsPanelVisible: true,
                    isDotsFixed: true,
                } })));
    }
    return null;
}
ProductFeatures.displayName = 'PDP_ProductFeatures_AEMComponent';
